import Avatar from "@visa/vds/avatar";
import AvatarText from "@visa/vds/avatar-text";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import LogoBlue from "@visa/vds/dist/_logos/visa/visa_vbm_blu.svg";
import Grid from "@visa/vds/grid";
import Icon from "@visa/vds/icon";
import Nav from "@visa/vds/nav";
import NavBrand from "@visa/vds/nav-brand";
import NavBrandInfo from "@visa/vds/nav-brand-info";
import NavBrandLogo from "@visa/vds/nav-brand-logo";
import NavBrandLogoImage from "@visa/vds/nav-brand-logo-image";
import NavUser from "@visa/vds/nav-user";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LoginUrlHelper } from "_helpers/LoginUrlHelper";
import { useAuthContextUser } from "../context/AuthContext";
import { PUBLIC_VSS_USER_ID } from "../_constants/GlobalConstants";
import { HOME_NAVIGATION } from "../_constants/PageRoutes";
import { TOP_NAV_ROUTES } from "../_constants/TopNavigationRoutes";
import MCSDesktopNav from "./MCSDesktopNav";
import MCSSearchBar from "./MCSSearchBar";
import MCSMobileNav from "./MCSMobileNav";

const MCSNav = (props) => {
  const user = useAuthContextUser();
  const currLocation = useLocation();
  const history = useHistory();
  const goHome = () => {
    setSelectedTab(null);
    history.push(HOME_NAVIGATION);
  };

  const getPathName = () => {
    let path = currLocation.pathname;
    let destPath = LoginUrlHelper.GetDestPath(path);
    let destUrl = process.env.REACT_APP_AUTHHOME + destPath;
    setPathName(process.env.REACT_APP_VOLHOME + encodeURIComponent(destUrl));
  };
  
  const signInClickHandler = () => {
    window.location.href = pathName;
  }

  const [pathName, setPathName] = useState(null);

  const [selectedTab, setSelectedTab] = useState(null);

  useEffect(() => {
    getPathName();
  }, [currLocation]);

  return (
    <Nav position="fixed" type="white" id="mcs-nav-white">
      <Grid className="mcs-nav-grid">
        <Row>
          <Col>
            { user &&
              <MCSMobileNav
                siteRoutes={TOP_NAV_ROUTES}
              />
            }
            <NavBrand>
              <NavBrandInfo>
                <NavBrandLogo onClick={goHome}>
                  <NavBrandLogoImage alt="Visa" src={LogoBlue} />
                  <Typography class="logo-title" tag="span">Secure Services</Typography>
                </NavBrandLogo>
              </NavBrandInfo>
            </NavBrand>
            { user && 
              <>
                <MCSDesktopNav
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  siteRoutes={TOP_NAV_ROUTES}
                />
                <NavUser>
                  {user.volUserId !== PUBLIC_VSS_USER_ID && (
                    <Avatar tag={<span />}>
                      <Icon
                        style={{ verticalAlign: "middle" }}
                        name="account"
                        resolution="low"
                        aria-hidden="false"
                      />
                      <AvatarText tag="p">
                        {user.volUserId}
                        <span>{ " | " + user.roleName}</span>
                        { user.organization &&
                          <>
                            <br />
                            <span>{user.organization.organizationName}</span>
                          </>
                        }
                      </AvatarText>
                    </Avatar>
                  )}            
                  {user.volUserId === PUBLIC_VSS_USER_ID && (
                    <ButtonText colorScheme="primary" onClick={signInClickHandler}>
                      Sign In
                    </ButtonText>
                  )}
                </NavUser>
                <MCSSearchBar />
              </>
            }
          </Col>
        </Row>
      </Grid>
    </Nav>
  );
};
export default MCSNav;
